import { useNavigate } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Page Not Found</h2>
        <p className="not-found-desc">
          Oops! The page you're looking for doesn't exist.
          Let's get you back on track.
        </p>
        <button onClick={() => navigate("/")} className="btn-home">
          Go Back Home
        </button>
      </div>
    </div>
  );
}
